import focusController from "@/utils/focusController"

let listeners = []

const directive = {
  bind(el, { value = () => {} } = {}) {
    let pendingClickTimerId = null

    const xorClickHandler = (event) => {
      if (pendingClickTimerId) {
        clearTimeout(pendingClickTimerId)

        pendingClickTimerId = null
      }

      const hasSelectedText = window.getSelection && window.getSelection().toString().length > 0

      if (hasSelectedText) {
        return
      }

      const notDoubleClick = event.detail === 1

      if (notDoubleClick || !hasSelectedText) {
        pendingClickTimerId = setTimeout(() => {
          const trEl = event.target.closest("tr")
          const uuid = trEl ? trEl.dataset.rowKey : ""

          if (uuid) {
            focusController.wrapper(event, () => value(uuid))
          }
        }, 180)
      }
    }

    el.addEventListener("click", xorClickHandler)

    listeners.push(el, xorClickHandler)
  },

  unbind() {
    listeners.forEach(({ el, handler }) => el && el.removeEventListener("click", handler))
    listeners = []
  }
}

export default directive
